import type {
  TypeArticleWithoutUnresolvableLinksResponse,
  TypeCategoryWithoutUnresolvableLinksResponse,
} from '@/bb-contentful-types'
import { removeDuplicates } from '@/blogBuilder/utils/articleUtils'

export const findArticleIds = (
  blogs: TypeCategoryWithoutUnresolvableLinksResponse[],
  articles: TypeArticleWithoutUnresolvableLinksResponse[],
  selectedCategory: string
) => {
  let items: TypeArticleWithoutUnresolvableLinksResponse[] = []

  if (articles.length) {
    items = articles
  } else if (selectedCategory.toLowerCase() === 'all') {
    blogs.forEach((category) => {
      const itemsInCategory = category?.fields?.articles

      if (itemsInCategory) {
        items.push(...itemsInCategory)
      }
    })

    // filters out duplications if there are
    items = removeDuplicates(items)
  }

  const articleIds = articles.map((d) => d.sys?.id)

  return articleIds
}
